import { Injectable } from '@angular/core';

import { AppSettings } from './../app.settings';
@Injectable()
export class AuthTokenService {

	public authTokenName = 'token';
	constructor() {
		// Set token name according to different login portal (LBPortal, AZPortal...)
		this.authTokenName = AppSettings.loginPortal === 'LBPortal' ? 'portalToken' : 'token';
	}
	getToken() {
		return localStorage.getItem(this.authTokenName);
	}

}
